<template>
 <div> <!-- Only one element for Transition -->
  <div class="row">
      <div class="col-12 col-sm-6">
        <TextInputComponent
          value-key="invoice.company"
          label="Société"
          placeholder="Indiquez votre société"
          :required="true"
          class="mb-3"
          :upper-case="true"
        />
      </div>
      <div class="col-12 col-sm-6">
        <TextInputComponent
          value-key="invoice.shopCode"
          label="Numéro de magasin"
          placeholder="Indiquez votre numéro de magasin"
          :required="true"
          class="mb-3"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6">
        <TextInputComponent
          value-key="invoice.lastName"
          label="Nom"
          placeholder="Nom"
          :required="true"
          class="mb-3"
          :upper-case="true"
        />
      </div>
      <div class="col-12 col-sm-6">
        <TextInputComponent
          value-key="invoice.firstName"
          label="Prénom"
          placeholder="Prénom"
          :required="true"
          class="mb-3"
          :capitalize="true"
        />
      </div>
      <div class="col-12 col-sm-6">
        <TextInputComponent
          value-key="invoice.address"
          label="Adresse de facturation"
          placeholder="Adresse de facturation"
          :required="true"
          class="mb-3"
        />
      </div>
      <div class="col-12 col-sm-6">
        <TextInputComponent
          value-key="invoice.zipCode"
          label="Code postal"
          placeholder="Code postal"
          :required="true"
          class="mb-3"
        />
      </div>
      <div class="col-12 col-sm-6">
        <TextInputComponent
          value-key="invoice.city"
          label="Ville"
          placeholder="Ville"
          :required="true"
          class="mb-3"
          :upper-case="true"
        />
      </div>
      <div class="col-12 col-sm-6">
        <SelectInputComponent
          value-key="invoice.country"
          label="Pays"
          placeholder="Sélectionnez un pays"
          :required="true"
          class="mb-3"
          :options="Countries"
          empty-option-label="Sélectionnez un pays"
        />
      </div>
  </div>
  <PageBottomMessage message-key="pageInvoice"></PageBottomMessage>
</div>
</template>

<script lang="ts" setup>
import { toRef } from 'vue'
import { Countries } from '@/compositions/nationalities'
import { usePostalCode } from '@/compositions/usePostalCode'
import { useField } from 'vee-validate';

const participation = defineModel<UserParticipation>()

const { setValue: setAddressCity,  } = useField<string>(() => 'invoice.city');
const postalCodeRef = toRef(() => participation.value?.invoice?.zipCode)
usePostalCode(postalCodeRef, (city) => setAddressCity(city))
</script>
